import format from "date-fns/format";

export interface NotifcationProps {
  action: string;
  event_signature: string;
  link: string;
  mt: string;
  notifier_name: string;
  notify_object_class_name: string;
  parent_object_name: string;
  guest_signature: string;
  id: number;
  direct_seen_at?: string;
  read_at?: string;
  direct_notified_at: string;
}

export interface NotificationsContextData {
  containsNew: boolean;
  notificationsList: NotifcationProps[];
}

export const initialState = {
  containsNew: false,
  notificationsList: [],
};

export const NOTIFICATIONS_FETCH_SUCCEEDED = "NOTIFICATIONS_FETCH_SUCCEEDED";
export const NOTIFICATIONS_FETCH_FAILED = "NOTIFICATIONS_FETCH_FAILED";
export const NOTIFICATIONS_READ_SUCCEEDED = "NOTIFICATIONS_READ_SUCCEEDED";
export const NOTIFICATIONS_READ_FAILED = "NOTIFICATIONS_READ_FAILED";

export const NotificationsReducer = (
  state: NotificationsContextData,
  action: any
) => {
  switch (action.type) {
    case NOTIFICATIONS_FETCH_SUCCEEDED:
      const notificationsList = action?.payload?.notifications || [];
      const containsNew = action?.payload?.new_notifications_count > 0 || false;
      return { ...state, notificationsList, containsNew };

    case NOTIFICATIONS_FETCH_FAILED:
      return { ...state, containsNew: false, notificationsList: [] };

    case NOTIFICATIONS_READ_SUCCEEDED:
      const oldList = state.notificationsList;
      const newList = oldList.map((notification) => {
        if (!notification.read_at) {
          notification.read_at =
            format(Date.now(), "YYYY-MM-DD[T]HH:mm:ss") + "Z";
        }
        return notification;
      });
      return { ...state, containsNew: false, notificationsList: newList };

    case NOTIFICATIONS_READ_FAILED:
      return { ...state };

    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
};
